import { GzFileSizesWebComponent } from './component/GzFileSizesWebComponent';

export { GzFileSizesWebComponent };
